import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Modal,
  Backdrop,
  Fade,
} from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import ApiPaginate from "../component/ApiPaginate";
import { CustomStyles } from "../component/CustomStyle";
import ApiEndpoints, { BASE_URL } from "../network/ApiEndPoints";
import { ddmmyy, dateToTime1 } from "../utils/DateUtils";
import DeleteNotification from "../modals/DeleteNotification";
import { Icon } from "@iconify/react";
import axios from "axios";
import ApporvePg from "../modals/ApporvePg";
import RejectPg from "../modals/RejectPg";
import AuthContext from "../store/AuthContext";
import FilterCard from "../modals/FilterCard";
import ApiPaginateSearch from "../component/ApiPaginateSearch";

 // 🔁 Replace with actual base URL

const AdminPgOrder = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const [imageURLs, setImageURLs] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  // const [token] = useState(localStorage.getItem("token"));
  const [refreshRef, setRefreshRef] = useState(null);
  const authCtx=useContext(AuthContext);
  const token=authCtx.token
  const fetchImage = async (fileName) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/${ApiEndpoints.GET_FILES}`,
        { fileName },
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );
      return URL.createObjectURL(new Blob([response.data]));
    } catch (error) {
      console.error("Error fetching image:", error);
      return null;
    }
  };

  const fetchImages = async () => {
    const newImageURLs = {};

    await Promise.all(
      apiData.map(async (user) => {
        const urls = {};

        if (user.pan_or_cc_front) {
          const panImage = await fetchImage(user.pan_or_cc_front);
          if (panImage) urls.pan = panImage;
        }

        if (user.aadhaar_front) {
          const frontImage = await fetchImage(user.aadhaar_front);
          if (frontImage) urls.aadhaar_front = frontImage;
        }
       if (user.customer_pic) {
          const customerImage = await fetchImage(user.customer_pic);
          if (customerImage) urls.customer_pic = customerImage;
        }

        if (user.aadhaar_back) {
          const backImage = await fetchImage(user.aadhaar_back);
          if (backImage) urls.aadhaar_back = backImage;
        }

        if (Object.keys(urls).length) {
          newImageURLs[user.id] = urls;
        }
      })
    );

    setImageURLs(newImageURLs);
  };

  useEffect(() => {
    if (apiData && apiData.length) {
      fetchImages();
    }
  }, [apiData]);

  const handleRefresh = () => {
    setQuery(""); 
    if (refreshRef) {
      refreshRef(); 
    }
  };

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenModal(true);
  };

  const closeImageModal = () => {
    setOpenModal(false);
  };

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
    },
    {
      name: "Created At",
      selector: (row) => (
        <div style={{ textAlign: "left" }}>
          {ddmmyy(row.created_at)} {dateToTime1(row.created_at)}
        </div>
      ),
    },
    {
      name: "Mobile",
      selector: (row) => row?.mobile,
    },
    {
      name: "PAN Front",
      selector: (row) =>
        imageURLs[row.id]?.pan ? (
          <img
            src={imageURLs[row.id].pan}
            alt="pan"
            style={{ width: 60, height: 40, objectFit: "cover", cursor: "pointer" }}
            onClick={() => openImageModal(imageURLs[row.id].pan)}
          />
        ) : (
          "Loading..."
        ),
    },
    {
      name: "Aadhaar Front",
      selector: (row) =>
        imageURLs[row.id]?.aadhaar_front ? (
          <img
            src={imageURLs[row.id].aadhaar_front}
            alt="aadhaar front"
            style={{ width: 60, height: 40, objectFit: "cover", cursor: "pointer" }}
            onClick={() => openImageModal(imageURLs[row.id].aadhaar_front)}
          />
        ) : (
          "Loading..."
        ),
    },
    {
      name: "Aadhaar Back",
      selector: (row) =>
        imageURLs[row.id]?.aadhaar_back ? (
          <img
            src={imageURLs[row.id].aadhaar_back}
            alt="aadhaar back"
            style={{ width: 60, height: 40, objectFit: "cover", cursor: "pointer" }}
            onClick={() => openImageModal(imageURLs[row.id].aadhaar_back)}
          />
        ) : (
          "Loading..."
        ),
    },
       {
      name: "Customer pic ",
      selector: (row) =>
        imageURLs[row.id]?.customer_pic ? (
          <img
            src={imageURLs[row.id].customer_pic}
            alt="aadhaar back"
            style={{ width: 60, height: 40, objectFit: "cover", cursor: "pointer" }}
            onClick={() => openImageModal(imageURLs[row.id].customer_pic)}
          />
        ) : (
          "Loading..."
        ),
    },
    {
      name: "Parent Id",
      selector: (row) => (
        <div className="blue-highlight-txt" style={{ textAlign: "left" }}>
          {row.parent}
        </div>
      ),
    },
    {
      name: "Aadhaar",
      selector: (row) => <div>{row.aadhaar}</div>,
    },
   {
  name: "Status",
  selector: (row) => {
    let statusText = "";
    let color = "";

    switch (row.status) {
      case 1:
        statusText = "Approved";
        color = "green";
        break;
      case 0:
        statusText = "Pending";
        color = "orange"; // yellow might be hard to read on white
        break;
      case 2:
        statusText = "Rejected";
        color = "red";
        break;
      default:
        statusText = "Unknown";
        color = "gray";
    }

    return (
      <div
        className="break-words"
        style={{
          textAlign: "left",
          display: "flex",
          justifyContent: "flex-start",
          color: color,
          fontWeight: "bold",
        }}
      >
        {statusText}
      </div>
    );
  },
  width: "100px",
  wrap: true,
},

    {
      name: <span className="mx-4">Actions</span>,
      selector: (row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            gap: 5,
          }}
        >

          <ApporvePg row={row} refresh={refreshRef} />
           <RejectPg row={row} refresh={refreshRef} />
        </div>
      ),
      center: true,
    },
  ];

  return (
    <>
 

      <ApiPaginateSearch
        apiEnd={ApiEndpoints.GET_CUSTOMER}
        ExpandedComponent={false}
        expandVisible={false}
        setQuery={setQuery}
        columns={columns}
        tableStyle={CustomStyles}
        apiData={apiData}
        setApiData={setApiData}
        queryParam={query}
        returnRefetch={(refetchFunc) => setRefreshRef(() => refetchFunc)}
         isFilterAllowed={true}
                filterComponent={
                  <FilterCard
                    showSearch={false}
                    query={query}
                 ifnumberFilter
                    setQuery={setQuery}
                    // ifFromBankFilter
                    // ifRoleFilter
                    // ifdateFilter
                    // ifnameFilter
          actionButtons={
            <>
                 <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Tooltip title="Refresh">
          <IconButton aria-label="refresh" sx={{ color: "#0F52BA" }} onClick={handleRefresh}>
            <CachedIcon />
          </IconButton>
        </Tooltip>
      </Box>
            </>
          }
                   
                
                  />
                }
        
      />

      {/* Image Preview Modal */}
      <Modal
        open={openModal}
        onClose={closeImageModal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={openModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              outline: "none",
            }}
          >
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Selected"
                style={{ maxWidth: "90vw", maxHeight: "80vh" }}
              />
            )}
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default AdminPgOrder;
